import { gatewayFetch, GATEWAY_BASE_URL } from './gateway.js';

let cachedServices = null;

/**
 * Fetches public catalog services from public_gateway.
 * Caches in-memory to prevent redundant network requests.
 */
export async function getServices(forceRefresh = false) {
  if (cachedServices && !forceRefresh) {
    return cachedServices;
  }

  const endpoint = '/api/v1/public/catalog/services';

  try {
    const data = await gatewayFetch(endpoint);
    const records = Array.isArray(data) ? data : (data.services || data.list || []);

    cachedServices = records.map(item => ({
      id: item.id || item.Id,
      name: item.name || item.ServiceName || 'Standard Service',
      category: item.category || item.Category || item.__Category || 'General',
      description: item.description || item.Description || '',
      priceTotal: Number(item.priceTotal || item.StandardPrice || item.price || 0),
      baseTimeHours: Number(item.baseTimeHours || item.BaseTimeHours || 1),
      imageUrl: item.imageUrl
        ? (item.imageUrl.startsWith('http') ? item.imageUrl : `${GATEWAY_BASE_URL}${item.imageUrl}`)
        : null
    }));

    return cachedServices;
  } catch (error) {
    console.error('Error fetching service catalog:', error);
    return [];
  }
}

/**
 * Extracts distinct categories from the active service catalog.
 */
export async function getCategories() {
  const services = await getServices();
  const categories = services
    .map(s => s.category)
    .filter(Boolean);

  return ['All', ...new Set(categories)];
}